import { render, staticRenderFns } from "./ModalCustoMensagens.vue?vue&type=template&id=3e143ed4&scoped=true&"
import script from "./ModalCustoMensagens.vue?vue&type=script&lang=js&"
export * from "./ModalCustoMensagens.vue?vue&type=script&lang=js&"
import style0 from "./ModalCustoMensagens.vue?vue&type=style&index=0&id=3e143ed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e143ed4",
  null
  
)

export default component.exports